import "./Login.css";
import { useEffect, useState } from 'react';
import { Button } from '../Button/button';
import { Formik } from 'formik';
import * as yup from 'yup';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { app } from '../firebase/firebase-config';
import axios from 'axios';


const loginSchema = yup.object().shape({
    email: yup.string().email('Invalid email').required('Email is required'),
    password: yup.string().min(8, 'Min 8 characters').max(64).required('Password is required')
});

const registerSchema = yup.object().shape({
    firstname: yup.string().required('First name is required'),
    lastname: yup.string().required('Last name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    password: yup.string().min(8, 'Minimum 8 characters').required('Password is required'),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], 'Passwords must match').required('Confirm password is required'),
    phone: yup.string(),
    isHealer: yup.boolean(),
    description: yup.string(),
    terms: yup.boolean().oneOf([true], 'You must accept the terms'),
});


const Login = () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [isRegistered, setIsRegistered] = useState(true);
    const auth = getAuth(app);



    const showForm = () => {
        if (!isRegistered) {
            return (
                <Formik
                    initialValues={{
                        firstname: '', lastname: '', email: '', password: '', confirmPassword: '',
                        phone: '',
                        isHealer: false, description: '', terms: false
                    }}
                    validationSchema={registerSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(true);
                        try {
                            const userCredential = await createUserWithEmailAndPassword(auth, values.email, values.password);
                            const token = await auth.currentUser.getIdToken(true);
                            document.cookie = `__session=${token};max-age=3600`;

                            const newUser = {
                                fbid: userCredential.user.id,
                                firstname: values.firstname,
                                lastname: values.lastname,
                                email: values.email,
                                password: values.password,
                                phone: values.phone,
                                isHealer: values.isHealer,
                                description: values.description,
                                terms: values.terms
                            };


                            const response = await axios.post(`${baseUrl}/users`, newUser);
                            window.location.assign(response.data?.url || '/');
                        } catch (err) {
                            alert("Error during registration: " + err.message);
                        } finally {
                            setSubmitting(false);
                        }
                    }}
                >
                    {({ values, handleChange, handleSubmit, setFieldValue, errors, touched }) => (
                        <form onSubmit={handleSubmit}>
                            <input type="text" name="firstname" value={values.firstname} onChange={handleChange} placeholder="First Name" />
                            {touched.firstname && errors.firstname && <div className="error">{errors.firstname}</div>}

                            <input type="text" name="lastname" value={values.lastname} onChange={handleChange} placeholder="Last Name" />
                            {touched.lastname && errors.lastname && <div className="error">{errors.lastname}</div>}

                            <input type="email" name="email" value={values.email} onChange={handleChange} placeholder="Email" />
                            {touched.email && errors.email && <div className="error">{errors.email}</div>}

                            <input type="password" name="password" value={values.password} onChange={handleChange} placeholder="Password" />
                            {touched.password && errors.password && <div className="error">{errors.password}</div>}

                            <input type="password" name="confirmPassword" value={values.confirmPassword} onChange={handleChange} placeholder="Confirm Password" />
                            {touched.confirmPassword && errors.confirmPassword && <div className="error">{errors.confirmPassword}</div>}

                            {/* Removed address, city, province, country, postalCode fields */}
                            <input type="text" name="phone" value={values.phone} onChange={handleChange} placeholder="Phone Number" />


                            <label>
                                <input
                                    type="checkbox"
                                    name="isHealer"
                                    checked={values.isHealer}
                                    onChange={(e) => setFieldValue("isHealer", e.target.checked)}
                                /> I am a healer
                            </label>

                            {values.isHealer && (
                                <>
                                    <label>Personal Description</label>
                                    <textarea name="description" value={values.description} onChange={handleChange} placeholder="Tell us about your healing practice..." />
                                </>
                            )}
                            <br></br>
                            <label>
                                <p onClick = {()=>{window.location.assign("/terms")}}>Terms and Conditions</p>
                                <input
                                    type="checkbox"
                                    name="terms"
                                    checked={values.terms}
                                    onChange={(e) => setFieldValue("terms", e.target.checked)}
                                />
                                I accept the terms
                            </label>
                            {touched.terms && errors.terms && <div className="error">{errors.terms}</div>}

                            <Button type="submit" className="btn btn-primary">Register</Button>
                        </form>
                    )}
                </Formik>
            );
        }

        return (
            <Formik
                initialValues={{ email: '', password: '' }}
                validationSchema={loginSchema}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    try {
                        await signInWithEmailAndPassword(auth, values.email, values.password);
                        const token = await auth.currentUser.getIdToken(true);
                        document.cookie = `__session=${token};max-age=3600`;
                        window.location.assign('/');
                    } catch (err) {
                        alert("Incorrect email or password");
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, errors, touched }) => (
                    <form onSubmit={handleSubmit}>
                        <input type="email" name="email" value={values.email} onChange={handleChange} placeholder="Email" />
                        {touched.email && errors.email && <div className="error">{errors.email}</div>}

                        <input type="password" name="password" value={values.password} onChange={handleChange} placeholder="Password" />
                        {touched.password && errors.password && <div className="error">{errors.password}</div>}

                        <Button type="submit" className="btn btn-primary">Login</Button>
                    </form>
                )}
            </Formik>
        );
    };

    return (
        <section id='login'>
            <div className='login-card'>
                <div className='header'>
                    <div className={isRegistered ? "active-tab" : ""} onClick={() => setIsRegistered(true)}>
                        <p>LOGIN</p>
                    </div>
                    <div className={!isRegistered ? "active-tab" : ""} onClick={() => setIsRegistered(false)}>
                        <p>REGISTER</p>
                    </div>
                </div>
                <div className='body'>
                    {showForm()}
                </div>
            </div>
        </section>
    );
};

export default Login;
